$(function() {

   screenWidth = $(window).width();

   function showHideFilters(){

    if ($(window).width() < 799) {
        sortParent = $('.sort-toggle').parent();
       $('.section_select').insertAfter(sortParent);



        mobileMenu = $('.container').children('.sidebar');

        $(mobileMenu).wrap( "<div class='mobile-filters'></div>" );

        $( ".mobile-menu-toggle" ).click(function( event ) {
            event.preventDefault();
            $(this).toggleClass('active');
            $('.mobile-filters').slideToggle( "fast", function() {
            });
        });

        $( ".sort-toggle" ).click(function( event ) {
            event.preventDefault();
            $(this).toggleClass('active');
            $('.section_select').slideToggle( "fast", function() {
            });
        });
    }
   }
   showHideFilters();
});